 <!-- Spinner -->
<div class="oauth-spinner">
<div class="spinner"></div>
<p>Connecting…</p>
</div>
